(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dnd-thermal-preview-links"] && !Shopify.designMode) return;
  try {
    (() => {
    const data = document.getElementById('DndThermalPreviewLinks');
    if (!data) return;
    const routes = JSON.parse(data.textContent);
    const connectPreviews = () => {
      document.querySelectorAll('a[href]').forEach((link) => {
        const destination = new URL(link.getAttribute('href'), window.location.origin);
        const preview = routes[destination.pathname];
        if (destination.origin === window.location.origin && preview) {
          link.setAttribute('href', preview + destination.hash);
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', connectPreviews, { once: true });
    } else {
      connectPreviews();
    }
    document.addEventListener('shopify:section:load', connectPreviews);
    const menuObserver = new MutationObserver(connectPreviews);
    menuObserver.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
